import { Carousel } from "@material-tailwind/react";
 
export function GalleryWithCarousel() {
  return (
    <Carousel loop={true} autoplay={true} className="rounded-xl overflow-hidden" placeholder="">
      <img
        src="/images/banner.jpeg"
        alt="Helping Wheel banner"
        className="h-full w-full object-cover object-center"
      />
      <img
        src="/images/awarded.jpeg"
        alt="Helping Wheel receiving an award"
        className="h-full w-full object-cover object-center"
      />
      <img
        src="/images/awarded2.jpeg"
        alt="Helping Wheel award presentation"
        className="h-full w-full object-cover object-center"
      />
      <img
            src="/images/tournament_Sponsor.jpeg"
            alt="Helping Wheel tournament sponsorship"
            className="h-full w-full object-cover object-center"
        />
    </Carousel>
  );
  }
